import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, GetAllProjectDto, LocationEmailReceiverDto, ProjectMemberImagesDto, ProjectServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
@Component({
    standalone: false,
    selector: 'app-projects-info-section',
    templateUrl: './projects-info-section.component.html',
    styleUrls: ['./projects-info-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectsInfoSectionComponent extends AppComponentBase implements OnInit {
    projectInfo: GetAllProjectDto[];
    isLoaded = false;
    isEmpty = true;
    istrueValue: boolean;
    viewAllPanelVisible = false;
    locationEmailReceiverDto: ProjectMemberImagesDto[] = [];
    dateTime = new Date();
    constructor(private _monitorService: MonitoringService, private _AllDashboardServiceProxy: AllDashboardServiceProxy, private _projectServiceProxy: ProjectServiceProxy, private router: Router, injector: Injector) { super(injector); }
    ngOnInit(): void {
        this.getUserTeamProjectdetails();
    }
    getUserTeamProjectdetails() {
        try {
            this._monitorService.logTrace("UI-getUserTeamProjectdetails", { "getUserTeamProjectdetails ": "getUserTeamProjectdetails: " + this.dateTime });
            //this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
            this._AllDashboardServiceProxy.getProjectDetails(false).pipe(
                finalize(() => {
                    this.isLoaded = true;
                    this.markForCheck();
                })
            ).subscribe({
                next: (result) => {
                    this.projectInfo = [];
                    this.isEmpty = true;
                    (result ?? []).forEach(x => {
                        if (!x) {
                            return;
                        }
                        if (!x.projectImage) {
                            x.projectImage = 'assets/common/images/new-dashboard/default-project-bag.svg';
                        }
                        (x.teamProfileImage ?? []).forEach(y => {
                            if (!y) {
                                return;
                            }
                            if (y.image === null || y.image === '') {
                                y.image = 'assets/common/images/default-profile-picture1.svg';
                            }
                            y['userImage'] = y.image;
                            y['userName'] = y.fullName;
                        });
                        if (!x.teamProfileImage) {
                            x.teamProfileImage = [];
                        }
                        this.projectInfo.push(x);
                        this.isEmpty = false;
                    });
                },
                error: (ex) => {
                    this._monitorService.logException(ex, 2);
                },
            });
            // this._projectServiceProxy.getProjectMemberImages().subscribe(result => {
            //     this.locationEmailReceiverDto = result;
            // })
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
            this.isLoaded = true;
            this.markForCheck();
        }
    }
    viewall() {
        this.router.navigate([AppRoutes.projects]);
    }
    redirectToViewPage(id: number, projectTypeId: number) {
        this.router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: id, option: projectTypeId }, queryParams: { ProjectId: id, option: projectTypeId } });
    }
}
